import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link, Redirect } from 'react-router-dom';
// Importação da tabela
import { Modal } from 'react-bootstrap';
import { Table } from 'react-bootstrap-table';
import TopoEstatico from '../Layout/TopoEstatico';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import AlertaInline from '../Miscelania/AlertaInline';
import RequestApi from '../Miscelania/RequestApi';
import ExamQuestionModal from './Elements/ExamQuestionModal';

class ExamsIndex extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      modal: false,
      dados: [],
      prova_selecionada: '',
      questao: {},
      questoes: {},
      opcoes: [],
      questao_selecionada: 'undefined',
      message_contest: '',
      exam_checked: false,
      button_close: false,
    };
    this.desativar_loading = this.desativar_loading.bind(this);
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.provas = this.provas.bind(this);
    this.chooseProva = this.chooseProva.bind(this);
    this.recarregarPagina = this.recarregarPagina.bind(this);
    this.recarregarProvas = this.recarregarProvas.bind(this);
    this.verificaProvaFinalizada = this.verificaProvaFinalizada.bind(this);

    //funções de dentro do modal
    this.showModal = this.showModal.bind(this);
    this.closeExamModal = this.closeExamModal.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.contestar = this.contestar.bind(this);
    this.redoneExam = this.redoneExam.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount () {
    var verifica_prova_finalizada = this.verificaProvaFinalizada();
    var self = this;
    Promise.resolve(verifica_prova_finalizada).then(function(value) {
      if (verifica_prova_finalizada === true) {
        var params = JSON.parse(localStorage.getItem("finalizada"));
        self.showModal(params);
        self.provas();
      } else {
        self.provas();
      }
      localStorage.setItem("finalizada", JSON.stringify(null));
    });
  }

  handleCheckboxChange(name, event) {
    // valor selecionado. Valores são true e false
    var value = event.target.checked;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = value;
    }
    this.setState(change);
    if (value === false) {
      this.setState({button_close: false});
    } else {
      this.setState({button_close: true});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verifica_mensagem");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({status_alerta: 1});
      self.setState({mensagem_alerta: message.mensagem_alerta});
      self.setState({tipo_alerta: message.tipo_alerta});
      localStorage.removeItem("verifica_mensagem");
    }
  }
  
  verificaProvaFinalizada() {
    var params = JSON.parse(localStorage.getItem("finalizada"));
    // Verifico se há alguma prova setada no storage
    //if(params === null) {
    if(params === null || typeof params === 'undefined') {
      return false;
    } else {
      return true;
    }
  }

  // Buscar infos da prova selecionada
  chooseProva(event) {
    var url = config.get('api') + '/prova/usuario/'+event.target.value;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var url = '/usuario/prova';
          self.props.setProva(responseJson.data);
          self.setState({redirect_url: url});
        } else {
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Buscar infos da prova selecionada
  redoneExam(event) {
    var url = config.get('api') + '/prova/usuario/refazer/'+event.target.value;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.provas();
        } else {
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  recarregarPagina(event){
    this.provas();
  }

  recarregarProvas(dados){
    this.provas();
  }
  closeExamModal(dados){
    var confirm = window.confirm('Tem certeza que gostaria de fechar? A prova não poderá mais ser revisada.');
    if (confirm) {
      this.setState({ modal: false });
    }
  }

  // Buscar infos das provas
  provas(e) {
    var storage = localStorage.getItem("cid");
    storage = JSON.parse(storage);
    var url = config.get('api') + '/provas/usuario/'+storage.aid;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
        self.handleMessage();
      });
    });
  }


  ///Funções de dentro do modal.
  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  questaoSelecionada (questao_selecionada) {
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });
  }

  buscarQuestoes (exam_id) {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + exam_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.state.questoes[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({
        questao: questao,
        opcoes: opcoes,
        message_contest: '',
      });
    }
  }
  
  showModal(event) {
    this.setState({ modal: true }, this.buscarQuestoes(event));
  }

  contestar(value) {
    var dados = {
      'question_id': value,
      'message': this.state.message_contest,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de contestar essa questão?');
    if (confirm) {
      var dados_salvar = {
        data: dados,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/contestar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
          self.setState({questoes: responseJson.data});
        }).catch((error) => {
          return error;
        });
      });
    }
  }


  render() {
    var indisponivel = 0;
    this.state.dados.map(function(dado, index) {
      if (dado.hour_exam_started !== null && dado.hour_exam_finish === null) {
        indisponivel = 1;
      }
    })

    var self = this;
    return (
<div>
  <TopoEstatico />
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading !== 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta === 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  {/*
  <section>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="filtro-provas">
            <div className="dropdown">
              <b>Filtrar por:</b>
              <Nav>
                <NavDropdown eventKey={3} title="Todas" id="basic-nav-dropdown">
                  <MenuItem eventKey={3.1}>Todas</MenuItem>
                  <MenuItem eventKey={3.2}>Finalizadas</MenuItem>
                  <MenuItem eventKey={3.3}>A fazer</MenuItem>
                </NavDropdown>
              </Nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  */}
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <br/>
        <button onClick={this.recarregarPagina} className="btn btn-info btn-lg btn-block"><i className="fa fa-fw fa-refresh"></i> Recarregar provas</button>
      </div>
    </div>
  </div>
  <section id="provas">
    <div className="container">
      <div className="row">
        {this.state.dados.map(function(dado, index) {
          if (indisponivel === 1 && dado.hour_exam_started === null) {
            dado.status_str = 'OUTRA PROVA EM ANDAMENTO';
          }
          return (
            <div className="col-md-4 text-center provas-quadrados">
              <div className="row">
                <div className="col-md-12">
                  <div className="provas-quadrados-fundo">
                    <div className="row">
                      <div className="col-md-8 col-md-offset-2">
                        <h4><b>{dado.exam_name}</b></h4>
                      </div>
                      <div className="col-md-2">
                        <div className={(dado.status === 'reprovada') ? "sinal sinal-vermelho" : (dado.status === 'aprovada') ? "sinal sinal-verde" : (dado.status_str === 'Indisponível' || dado.hour_exam_started !== null) ? "sinal sinal-cinza" : (dado.status_str === 'Disponível') ? "sinal sinal-azul" : "sinal"}></div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <p><b>Aluno:</b> {dado.staff.name}</p>
                        <p><b>Código:</b> {dado.id}</p>
                        {(dado.training !== null) ?
                          <p><b>Treinamento:</b> {dado.training.name}</p>
                        :
                          <p><b>Treinamento:</b> Prova avulsa</p>
                        }
                        <p><b>Matéria:</b> {dado.matter.name}</p>
                        <p className="provas-quadrados-status"><b>Status:</b> <span className={(dado.status === 'reprovada') ? "label-danger" : (dado.status === 'aprovada') ? "label-success" : (dado.status_str === 'Indisponível' || dado.hour_exam_started !== null || indisponivel === 1) ? "label-indisponivel" : (dado.status_str === 'Disponível') ? "label-primary" : "label-warning"}>{dado.status_str}</span></p>
                        {(dado.hour_exam_started !== null) ?
                          <div>
                            <p><b>Início:</b> {dado.date_exam_start_str} {dado.hour_exam_started}</p>
                            <p><b>Fim:</b> {dado.date_exam_start_str} {dado.hour_exam_finish}</p>                            
                          </div>
                        :
                          <div>
                            <p><b>Início:</b> {dado.exam_start_str}</p>
                            <p><b>Fim:</b> {dado.exam_finish_str}</p>                            
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  {(dado.status === 'reprovada') ? <button value={dado.id} onClick={''} className='btn-block button-prova-reprovada'>REPROVADA</button> : (dado.status === 'aprovada') ? <button value={dado.id} onClick={''} className='btn-block button-prova-aprovada'>APROVADA</button> : (dado.status_str === 'Indisponível') ? <button value={dado.id} className='btn-block button-indisponivel-prova'>INDISPONÍVEL</button> : (dado.hour_exam_started !== null) ? <button value={dado.id} className='btn-block button-indisponivel-prova'>INDISPONÍVEL - JÁ INICIADA</button> : (indisponivel === 1) ? <button value={dado.id} className='btn-block button-indisponivel-prova'>INDISPONÍVEL</button> : (dado.status_str === 'Disponível') ? <button value={dado.id} onClick={self.chooseProva} className='btn-block button-iniciar-prova'>INICIAR PROVA</button> : ''}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
          {(typeof self.state.questoes[0] !== 'undefined') ?
            <h4 className="pull-left"><b>Revise sua prova</b> - Resultado: {self.state.questoes[0].team_training_matter_staff_exam.result}% - {(self.state.questoes[0].team_training_matter_staff_exam.status === 'reprovada') ?
            <span className="label label-danger">REPROVADO</span>
            : 
              <span className="label label-success">APROVADO</span>
            }</h4>
          : 
            ''
          }
            
        </div>
        <div className="col-md-6">
          <input
          name="exam_checked"
          type="checkbox"
          checked={this.state.exam_checked}
          style={{transform: 'scale(1.8)', marginRight: '15px'}}
          onChange={this.handleCheckboxChange.bind(this, 'exam_checked')} />&nbsp; <strong style={{fontSize: '18px'}}>Confirmo que a prova foi revisada</strong>
          {self.state.button_close ?
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeExamModal}><i className="fa fa-fw fa-close"></i></button>
          : 
            <button className="btn btn-danger btn-sm pull-right" disabled><i className="fa fa-fw fa-close"></i></button>
          }
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      {(typeof self.state.questoes[0] !== 'undefined') ?
        (self.state.questoes[0].team_training_matter_staff_exam.interrupted === 1) ? 
          <h3 className="label-danger">Prova interrompida pelo controlador</h3>
          :
          ''
        : 
        ''
      }
      <div className="row">
        <div className="col-md-12">
          <p>Para contestar uma resposta, basta selecionar a questão e escrever uma justificativa.</p>
        </div>
      </div>
      <div className="row">
        {Object.keys(self.state.questoes).map(function(k) {
          return (
            <div className="col-md-1">
              <div onClick={() => self.questaoSelecionada(k)} className={(self.state.questoes[k].contested === 1) ? "modal-prova-quadrado-questoes-fundo quadrado-contestada" : (self.state.questoes[k].selected == self.state.questoes[k].option_correct_number) ? "modal-prova-quadrado-questoes-fundo quadrado-correta" : "modal-prova-quadrado-questoes-fundo quadrado-incorreta"}>
                <h5>{(self.state.questoes[k].selected) ? self.state.questoes[k].question_number + ' - ' + self.state.questoes[k].selected_str : self.state.questoes[k].question_number}</h5>
              </div>
            </div>
          );
        })}
      </div>
      <hr/>
      {(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') ?  '' :
        <div>
          <h4>{this.state.questao.question_number}</h4>
          <hr/>
          <div className="pull-left" dangerouslySetInnerHTML={{__html: this.state.questao.question_content}}></div>
          <div className="pull-right">{this.state.questao.question_name}</div>
          <div className="clearfix"></div>
          <hr/>
          <table className="table tabela-questao-opcoes">
            <tbody>
              {Object.keys(self.state.opcoes).map(function(k) {
                return (
                  <tr>
                    <td className="checkbox-questao-opcoes"><div className={(self.state.opcoes[k].selected == 1) ? 'opcao-selecionada' : 'opcao'}>{(self.state.opcoes[k].selected == 1) ? 'X' : ''}</div></td>
                    <td><span>{self.state.opcoes[k].option_number}) </span>{self.state.opcoes[k].option_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <hr/>
            <h3 className="text-center">Opção correta: <span className="opcao-correta">{this.state.questao.option_correct_number}</span></h3>
          <hr/>
          {(self.state.status_alerta == 1) ? <div><AlertaInline mensagem={self.state.mensagem_alerta} tipo={self.state.tipo_alerta} desativar={self.desativar_alerta} /><br/></div> : ""}
          <label>Contestar questão:</label>
          <textarea style={{ height: 200 }} disabled={self.state.questao.contested === 1 ? 'disabled' : ''} value={self.state.questao.message ? self.state.questao.message : self.state.message_contest} type="text" name="content" className="form-control" placeholder="Escreva uma mensagem explicando o motivo da contestação" onChange={self.handleChange.bind(self, 'message_contest')} />
          <br/>
          <div className="row">
            <div className="col-md-4 col-md-offset-4">
              <button className="btn-block button-modal-prova-confirmar" onClick={()=>self.contestar(self.state.questao.id)}>ENVIAR CONTESTAÇÃO</button>
            </div>
          </div>
          <hr/>
          <div className="row dados-prova-modal">
            <div className="col-md-6">
                <p><b>Código: </b>{this.state.questoes[0].team_training_matter_staff_exam.id}</p>
                {(this.state.questoes[0].training !== null) ?
                  <p><b>Treinamento: </b>{this.state.questoes[0].training.name}</p>
                :
                  <p><b>Treinamento: </b>Prova avulsa</p>
                }
                <p><b>Matéria: </b>{this.state.questoes[0].matter.name}</p>
                <p><b>Status: </b><span className={(self.state.questoes[0].team_training_matter_staff_exam.status == 'aprovada') ? 'label-success' : 'label-danger'}>{(self.state.questoes[0].team_training_matter_staff_exam.status == 'aprovada') ? 'Aprovada' : 'Reprovada'}</span></p>
                <p><b>Início: </b>{this.state.questoes[0].team_training_matter_staff_exam.exam_start_str}</p>
                <p><b>Fim: </b>{this.state.questoes[0].team_training_matter_staff_exam.exam_finish_str}</p>
            </div>
            <div className="col-md-6">
                <p><b>Total de questões: </b>{this.state.questoes[0].team_training_matter_staff_exam.qtd_questoes}</p>
                <p><b>Acertos: </b>{this.state.questoes[0].team_training_matter_staff_exam.qtd_acertadas}</p>
                <p><b>Erros: </b>{this.state.questoes[0].team_training_matter_staff_exam.qtd_erradas}</p>
                <p><b>Nota: </b>{this.state.questoes[0].team_training_matter_staff_exam.result}</p>
                <p><b>Tempo total de prova:</b> 00:40:00</p>
            </div>
          </div>
        </div>
      }
    </Modal.Body>
  </Modal>
</div>
    );
  }
}

export default ExamsIndex;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamsIndex.js